document.addEventListener('DOMContentLoaded',()=>{

const menu=document.querySelector('.contact-menu');

if(!menu) return;

const button=menu.querySelector('.contact-toggle');
const dropdown=menu.querySelector('.contact-dropdown');

button.addEventListener('click',(e)=>{

e.stopPropagation();

dropdown.classList.toggle('open');

});

document.addEventListener('click',(e)=>{

if(!menu.contains(e.target)){

dropdown.classList.remove('open');

}

});

document.addEventListener('keydown',(e)=>{

if(e.key==="Escape"){

dropdown.classList.remove('open');

}

});

});